import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { PersonPointDTO } from 'app/dtos/person-point/person-point';
import { ConfirmedPersonPoint } from 'app/dtos/person-point/confirmed-person-points';
import { SelectedPersonsPointDto } from 'app/dtos/person-point/selected-person-point';
import { _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class PersonPointService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllPersonPoint(page, size, startDate, endDate, status, personId, confirmed, workingStatus, search, depertmantIds) {
    let queryParams = `page=${page}&size=${size}`;

    if (depertmantIds && depertmantIds.length > 0) {
      depertmantIds.forEach(id => {
        queryParams += `&DepertmantIds=${id}`;
      });
    }
    if (startDate) {
      queryParams += `&StartDate=${startDate}`;
    }
    if (endDate) {
      queryParams += `&EndDate=${endDate}`;
    }
    if (status !== undefined && status !== null && status.length > 0) {
      status.forEach(status => {
        queryParams += `&Statuses=${status}`;
      });
    }
    if (personId !== undefined && personId !== null) {
      queryParams += `&PersonId=${personId}`;
    }
    if (confirmed !== undefined && confirmed !== null) {
      queryParams += `&confirmed=${confirmed}`;
    }
    if (workingStatus != null)
      queryParams += `&workingStatus=${workingStatus}`;

    if (search !== null || search !== undefined)
      queryParams += `&Search=${search}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonPoint,
      queryString: queryParams
    });

    return await firstValueFrom(observable);
  }


  async getPersonPoints(page, size, search, personId, startDate?: string, endDate?: string, status?: number, confirmed?: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonPoint,
      queryString: `page=${page}&size=${size}&search=${search}&personId=${personId}&startDate=${startDate}&endDate=${endDate}&status=${status}&confirmed=${confirmed}`,
      action: "GetPersonPoints"
    });
    return await firstValueFrom(observable);
  }

  async getByIdPersonPoint(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonPoint
    }, id);
    return await firstValueFrom(observable);
  }

  async calculatePersonPoints(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.PersonPoint,
      action: "CalculatePersonPoints"
    }, id);
    return await firstValueFrom(observable);
  }

  async cretaPersonPoint(createPersonPoint: PersonPointDTO) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.PersonPoint
    },
      {
        personId: createPersonPoint.personId,
        workStart: createPersonPoint.workStart,
        workEnd: createPersonPoint.workEnd,
        workRate: createPersonPoint.workRate,
        overtimeHours: createPersonPoint.overtimeHours,
        status: createPersonPoint.status,
        description: createPersonPoint.description,
        appUserId:Number(_isId ?? null)
      });
    return await firstValueFrom(observable);
  }

  async selectedPersonsPoint(selectedPersonsPointDto: SelectedPersonsPointDto) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.PersonPoint,
      action: "SelectedPersonsPoint"
    }, selectedPersonsPointDto);
    return await firstValueFrom(observable);
  }

  async updatePersonPoint(updatePersonPoint: PersonPointDTO) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonPoint
    },
      {
        id: updatePersonPoint.id,
        personId: updatePersonPoint.personId,
        workStart: updatePersonPoint.workStart,
        workEnd: updatePersonPoint.workEnd,
        workRate: updatePersonPoint.workRate,
        overtimeHours: updatePersonPoint.overtimeHours,
        status: updatePersonPoint.status,
        description: updatePersonPoint.description,
        appUserId:Number(_isId ?? null)
      });
    return await firstValueFrom(observable);
  }

  async assignWorkPoints(date: Date) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.PersonPoint,
      action: "assign-work-points"
    }, {
      date: date
    });
    return await firstValueFrom(observable);
  }

  async confirmedPersonPoint(id, confirmed) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonPoint,
      action: "ConfirmedPersonPoint"
    }, {
      id: id,
      confirmed: confirmed
    });
    return await firstValueFrom(observable);
  }

  async confirmedPersonPoints(confirmedPersonPoints: ConfirmedPersonPoint[]) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.PersonPoint,
      action: "ConfirmedPersonPoints"
    }, confirmedPersonPoints);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
